export default __webpack_public_path__ + "media/images/images/logo/logo-light-lg-56149d959548ee67d008dd5675cb1b94.png";